import "./App.css";
import React from "react";
import { Route } from "react-router";
import Layout from "./components/Layout";
import { library } from "@fortawesome/fontawesome-svg-core";
// eslint-disable-next-line
import fontawesome from "@fortawesome/fontawesome-pro";
import { faPlay, faStop, faVolume, faVolumeSlash, faBars, faSquare, faCheckSquare } from "@fortawesome/pro-light-svg-icons";
import { faExclamationTriangle, faStopwatch, faMindShare, faClock, faBook, faAbacus, faShapes, faCogs, faFunction, faQuoteLeft, faBallot, faCheck } from "@fortawesome/pro-regular-svg-icons";
import Assessment from "./components/Assessment";

library.add(faPlay, faStop, faVolume, faVolumeSlash, faBars, faSquare, faCheckSquare);
library.add(faExclamationTriangle, faStopwatch, faMindShare, faClock, faBook, faAbacus, faShapes, faCogs, faFunction, faQuoteLeft, faBallot, faCheck);

export default () => (
<Layout>
    <Route path="/Assessment/:key?" component={Assessment} />
</Layout>
);
